import styled from "styled-components";

export const Ellipse = styled.div`
  position: absolute;
  width: 29.5rem;
  height: 27.3125rem;
  border-radius: 100%;
  filter: blur(3.12rem);
  background-color: #f7eed6;
  opacity: 30%;
`;

export const EllipseLeft = styled(Ellipse)`
  left: -24.75rem;
  top: 35em;
`;
export const EllipseLeft2 = styled(Ellipse)`
  left: -14.75rem;
  top: calc(35em + 20rem);
`;
export const EllipseLeft3 = styled(Ellipse)`
  width: 15.875rem !important;
  height: 15.875rem !important;
  left: 10rem;
  top: calc((42.5em) + 6.828125rem);
`;

export const EllipseRight = styled(Ellipse)`
  top: 10rem;
  right: -24.75rem;
`;
export const EllipseRight2 = styled(Ellipse)`
  top: 30rem;
  right: -14.75rem;
`;
export const EllipseRight3 = styled(Ellipse)`
  top: calc((16em) + 6.828125rem);
  width: 15.875rem !important;
  height: 15.875rem !important;
  right: 10rem;
`;
